export const panoramicSplit = `background: bahaus
title: Savanna — 0.5 t C/ha/yr
  align: center
  shadow:over-image
|
background: sigmund
title: Temperate Forest — 3.8 t C/ha/yr
  align: center
  shadow:over-image
|
background: subway
title: Tropical Rainforest — 7.6 t C/ha/yr
  align: center
  shadow:over-image`